import React, { Component } from 'react';
import { Icon, Form, Button, Modal, Table, Segment, Header, Label } from 'semantic-ui-react';
import Comment from './Comment';
import AddComment from './AddComment';
import Dropzone from 'react-dropzone';
import { uploadAlertFile } from '../../utils/rest';
class Docs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openComment: false,
            docDetails: [],
            actionDetails: [],
            clients: [],
            docs: true,
            currentDocUpload: "",
            uploadDetails: []
        };
    }

    openComment = () => {
        this.setState({
            openComment: true
        })
    }
    closeComment = () => {
        this.setState({
            openComment: false
        })
    }

    setDocmentId = (doc) => {
        this.setState({
            currentDocUpload: doc.documentId
        }, () => {
            this.refs.dropzone.open();
        })
    }

    onDrop = (acceptedFiles, isMatter) => {
        // do stuff with files…
        const data = new FormData()
        acceptedFiles.forEach(file => {
            data.append('files', file);
        });

        uploadAlertFile(data).then((response) => {
            if (response !== null && response instanceof Array) {
                let uploadDetails = this.state.uploadDetails.filter((upload) => {
                    return upload.documentId !== this.state.currentDocUpload
                });
                uploadDetails.push({
                    documentId: this.state.currentDocUpload,
                    file: response,
                    isMatter: isMatter
                });
                this.setState({
                    uploadDetails
                })
            }
        })
    }

    removeDocs = (attachmentid) => {
        let uploadDetails = [];
        this.state.uploadDetails.forEach((upload) => {
            upload.file.forEach((attachment, index) => {
                if (attachment.id !== attachmentid) {
                    uploadDetails.push({
                        documentId: upload.documentId,
                        file: [attachment]
                    });
                }
            })
        });

        this.setState({
            uploadDetails
        });
    }

    showFileUpload = (doc, index, isMatter) => {
        let hasDocument = [];
        hasDocument[index] = false;
        this.state.uploadDetails.forEach((isUpload) => {
            if (isUpload.documentId === doc.documentId) {
                hasDocument[index] = true;
                return;
            }
        });
        return (
            <Form key={index} style={{ display: hasDocument[index] ? "none" : "block" }}>
                <Dropzone ref="dropzone" multiple={true} style={{
                    position: "relative",
                    height: "50px",
                    borderWidth: "2px",
                    borderColor: "rgb(102, 102, 102)",
                    borderStyle: "dashed",
                    borderRadius: "5px",
                    textAlign: "center",
                    display: "none"
                }} onDrop={(files) => this.onDrop(files, isMatter)}>
                    Try dropping some files here, or click to select files to upload.
                                                                            </Dropzone>
                <Button
                    icon="upload"
                    label={{
                        basic: true,
                        content: 'Browse file'
                    }}
                    labelPosition="right"
                    onClick={() => { this.setDocmentId(doc); }}
                />
            </Form>
        );
    }

    addComment = (doc) => {
        this.setState({
            openComment: true,
            docDetails: doc
        })
    }

    handleSubmit = (comment) => {
        this.props.handleSubmit(this.state.docDetails, comment.comment, false);
    }

    render() {
        return (
            <div>
                <Modal size="large" open={this.props.open} onClose={this.props.close} closeIcon>
                    <Modal.Header>Resolve Docs Request</Modal.Header>
                    <Modal.Content>
                        <Table inverted className="grey celled striped small" >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell className="four wide" data-inverted="" data-tooltip="Consumer’s Name [Format: Lastname, Firstname]" data-position="top left">Lastname, First Name</Table.HeaderCell>
                                    <Table.HeaderCell className="four wide" data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="top left">Client Acct#</Table.HeaderCell>
                                    <Table.HeaderCell className="four wide" data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="top left">Our Acct#</Table.HeaderCell>
                                    <Table.HeaderCell className="four wide" data-inverted="" data-tooltip="Current Total Due" data-position="top left">Total</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>{this.props.data.conLastName + ", " + this.props.data.conFirstName}</Table.Cell>
                                    <Table.Cell>{this.props.data.acoInvoiceId}</Table.Cell>
                                    <Table.Cell>{this.props.data.acoAccountId}</Table.Cell>
                                    <Table.Cell textAlign='right'>{this.props.data.acoTotal}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                        <Segment.Group raised>
                            <Segment.Group horizontal>
                                <Segment color="grey" inverted>
                                    <Header as="h4">
                                        <Icon name="file outline" />
                                        <div className="content">
                                            Docs Needed
                                     </div>
                                    </Header>
                                </Segment>
                                <Segment color="grey" inverted>
                                    <div style={{ textAlign: "right" }}>Fax: {this.props.config.FAX_NUMBER ? this.props.config.FAX_NUMBER : ""}</div>
                                </Segment>
                            </Segment.Group>
                            <Table className="celled striped small" >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell className="" data-inverted="" data-tooltip="Document Type Requested" data-position="top left">Doc Type</Table.HeaderCell>
                                        <Table.HeaderCell className="" data-inverted="" data-tooltip="Date Our Request was Submitted" data-position="top left">Request Date</Table.HeaderCell>
                                        <Table.HeaderCell className="" data-inverted="" data-tooltip="Status on Document Request" data-position="top left">Doc Status</Table.HeaderCell>
                                        <Table.HeaderCell className="" data-inverted="" data-tooltip="Status on Document Request" data-position="top left">Collector Remark</Table.HeaderCell>
                                        <Table.HeaderCell className="" data-inverted="" data-tooltip="Date Received" data-position="top left">Document Received</Table.HeaderCell>
                                        <Table.HeaderCell className="" data-inverted="" data-tooltip="Click Browse Button to Upload" data-position="top left">Upload</Table.HeaderCell>
                                        <Table.HeaderCell className="" data-inverted="" data-tooltip="Click Browse Button to Upload" data-position="top left" width={2} textAlign="center">Other Actions</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        (() => {
                                            return this.props.sameAccountOtherDocs.map((doc, index) => {
                                                return (
                                                    <Table.Row key={index}>
                                                        <Table.Cell className="collapsing">
                                                            <Icon name="file"></Icon> {this.props.getDocDesc(doc.requestDoc)}
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {this.props._formatDate(doc.requestDate)}
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <Icon name="circle" className="red small"></Icon> {doc.documentStatus}
                                                        </Table.Cell>
                                                        <Table.Cell width={4}>
                                                             {doc.ctdCollectorRemarks}
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {this.showFileUpload(doc, index, this.props.data.isMatter)}
                                                            {
                                                                (() => {
                                                                    // eslint-disable-next-line
                                                                    return this.state.uploadDetails && this.state.uploadDetails.map((upload, index) => {
                                                                        if (upload.documentId === doc.documentId) {
                                                                            return upload.file && upload.file.map((attachment, index) => {
                                                                                return (
                                                                                    <Label as='a' key={index}>
                                                                                        {/*<Icon name='download' onClick={() => { this.downloadFiles(attachment.id) }} /> */}
                                                                                        {attachment.filename}
                                                                                        <Icon name='delete' onClick={() => { this.removeDocs(attachment.id) }} />
                                                                                    </Label>
                                                                                )

                                                                            })
                                                                        }
                                                                    })
                                                                })()
                                                            }
                                                        </Table.Cell>
                                                        <Table.Cell textAlign="center">
                                                            <Button onClick={this.props.handleSubmit.bind(this, doc, "Will Fax in Within Three (3) Business Days", true)} className="ui icon mini button" data-inverted="" data-tooltip="Will Fax in Within Three (3) Business Days" data-position="top left">
                                                                <Icon name="fax"></Icon>
                                                            </Button>
                                                            <Button onClick={this.props.handleSubmit.bind(this, doc, "Cannot Locate - or - Do Not Have", true)} className="ui icon mini button" data-inverted="" data-tooltip="Cannot Locate - or - Do Not Have" data-position="top left">
                                                                <Icon name="search minus"></Icon>
                                                            </Button>
                                                            <Button onClick={() => { this.addComment(doc) }} className="ui icon mini button" data-inverted="" data-tooltip="Add Comment" data-position="top left">
                                                                <Icon name="comments outline"></Icon>
                                                            </Button>
                                                        </Table.Cell>
                                                    </Table.Row>
                                                )
                                            })
                                        })()
                                    }
                                </Table.Body>
                            </Table>
                            <Segment secondary clearing>
                                <div>
                                    <Button className="ui right floated small button" onClick={this.props.resolveDocuments.bind(this, this.state.uploadDetails, this.props.data.acoAccountId)}>Submit Upload(s)</Button>
                                </div>
                            </Segment>
                        </Segment.Group>
                        <Comment {...this.props} history={this.props.history} commentDetails={this.props.data.commentDetails} type="doc" handleSubmit={this.props.handleSubmit} data={this.props.sameAccountOtherDocs} docRequestPending={this.props.sameAccountOtherDocs.map((i) => {
                            return i.requestDoc
                        })} />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.props.close}>{this.props.t("close")}</Button>
                    </Modal.Actions>
                </Modal>
                <Modal size="small" open={this.state.openComment} onClose={this.closeComment} style={{ background: "none" }}>
                    <AddComment showDropdownList={false} shortCommentNote={"Enter a comment below to alert us of any information you'd like us to have for this request."} docList={["R"]} closeComment={this.closeComment} {...this.props} handleSubmit={this.handleSubmit} />
                </Modal>
            </div>

        );
    }
}
export default Docs;


// WEBPACK FOOTER //
// ./src/app/ui/alerts/Docs.js